<template>
  <div class="goverment">
    <div class="header">
      <el-page-header @back="goBack" title="Home" content="Corporate Governance">
        <span slot="content" class="page-title">
          Corporate Governance
        </span>
      </el-page-header>
    </div>
    <div class="body">
      <el-input placeholder="Filter keyword" size="small" v-model="filterText" class="main-filter"
        @keydown.native="typeFilter">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
        <div slot="append" style="width: max-content;">
          <el-button type="primary" size="small" @click="searching" :loading="load.searching">Search</el-button>
          <el-button type="danger" size="small" @click="resetsearching" v-if="search.status">Reset</el-button>
        </div>
      </el-input>
      <div class="tree-wrapper">
        <div class="tree-content">
          <el-table v-if="search.status" :data="search.result" size="small" :show-header="false"
            class="table-result-search" style="width: 100%;background:none!important">
            <el-table-column>
              <template slot-scope="scope">
                <div class="rows">
                  <div>
                    <el-link :href="base_url_cloud + scope.row.link" target="_blank">{{ scope.row.label }}</el-link>
                  </div>
                  <div class="stat" v-if="!isMobile">
                    Created : {{ scope.row.created }} | Modified : {{ scope.row.modified }} | Size : {{ scope.row.size }}
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-tree :hidden="search.status" class="filter-tree" style="font-size: inherit!important;" lazy :data="data"
            :props="defaultProps" :load="loadNode" ref="tree">
            <div class="custom-tree-node" slot-scope="{ node, data }">
              <div>
                <el-button type="text" size="medium" :icon="data.type == 'file' ? 'el-icon-document' : 'el-icon-folder'"
                  :class="'tree-btn-action'" @click="(event) => actions(event, data)">
                </el-button>
                <!-- <el-popover
                    placement="top-start"
                    width="300"
                    trigger="hover">
                      <el-button slot="reference"
                        type="text"
                        size="mini"
                        :icon="data.type == 'file' ? 'el-icon-document' : 'el-icon-folder'"
                        :class="'tree-btn-action'"
                        @click="(event) => actions(event, data)">
                      </el-button>
                      <el-button-group style="width:100%">
                        <el-button type="primary" size="mini" style="width:45%" @click="handleAddSubData(data)">Add New Sub Level</el-button>
                        <el-button type="primary" size="mini" class="edit-btn" style="width:30%" @click="handleEditData(data)">Edit Label</el-button>
                        <el-button type="danger" size="mini" style="width:25%">Delete</el-button>
                      </el-button-group>
                  </el-popover> -->

                <span v-if="data.type == 'file'" @click="gotoLink(base_url_cloud + data.url)"><el-link>{{ data.label
                }}</el-link></span>
                <span v-else><b>{{ data.label }}</b></span>
              </div>
              <div class="stat" v-if="data.type == 'file' && !isMobile">
                Created : {{ data.created }} | Modified : {{ data.modified }} | Size : {{ data.size }}
              </div>
            </div>
          </el-tree>
          <!-- <div style="margin-top:25px">
            <el-button type="primary" size="small" class="fitContent" style="margin-left:10px" @click="handleAddData()">Add New Top Level</el-button>
            </div> -->
        </div>
      </div>
    </div>
    <el-dialog title="Entry New Data" :visible.sync="dialogNewData" :modal="true" :modal-append-to-body="false"
      :close-on-click-modal="false">
      <el-form :model="form">
        <el-form-item label="Parent" :label-width="formLabelWidth" v-if="form.id_parent != ''">
          <el-input v-model="form.lbl_parent" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="Label" :label-width="formLabelWidth">
          <el-input v-model="form.label" autocomplete="off" @keypress.native="onEnter"></el-input>
        </el-form-item>
        <el-form-item label="As" :label-width="formLabelWidth" v-if="form.id_parent != ''">
          <el-radio-group v-model="form.as" @change="changeAs">
            <el-radio-button label="child">Only Child</el-radio-button>
            <el-radio-button label="parent">Parent</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Link" :label-width="formLabelWidth" v-if="form.id_parent != ''">
          <el-input v-model="form.link" autocomplete="off" :disabled="form.as == 'parent'"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="dialogNewData = false">Cancel</el-button>
        <el-button type="primary" @click="saveDataEntry(null)">Confirm</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Edit Data" :visible.sync="dialogEditData" :modal="true" :modal-append-to-body="false"
      :close-on-click-modal="false">
      <el-form :model="form">
        <el-form-item label="Label" :label-width="formLabelWidth">
          <el-input v-model="form.label" autocomplete="off" @keypress.native="onEnter"></el-input>
        </el-form-item>
        <el-form-item label="As" :label-width="formLabelWidth" v-if="form.id_parent != ''">
          <el-radio-group v-model="form.as" @change="changeAs">
            <el-radio-button label="child">Only Child</el-radio-button>
            <el-radio-button label="parent">Parent</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Link" :label-width="formLabelWidth" v-if="form.id_parent != ''">
          <el-input v-model="form.link" autocomplete="off" :disabled="form.as == 'parent'"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="dialogEditData = false">Cancel</el-button>
        <el-button type="primary" @click="saveDataEntry(null)">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "CorporateGovernance",
  data() {
    return {
      filterText: '',
      data: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        isLeaf: 'leaf'
      },
      dialogNewData: false,
      dialogEditData: false,
      form: {
        label: '',
        link: '',
        id_parent: null,
        lbl_parent: null,
        path: null,
        as: null,
        id: null,
      },
      formLabelWidth: '75px',
      load: {
        searching: false,
      },
      search: {
        result: [],
        status: false,
      }
    };
  },
  computed: {
    ...mapGetters({ corGovList: "getListCorGov", activeUser: "getActiveUser" }),
    base_url_cloud() {
      return process.env.VUE_APP_CLOUD_PATH
    }

  },
  watch: {
    // filterText(val) {
    //   this.$refs.tree.filter(val);
    // }
  },
  mounted() {
    // this.fs.readdir(location.host+"/abc/", function (err, list) {
    //   if (err) throw err;
    //   for (var i = 0; i < list.length; i++) {
    //     if (path.extname(list[i]) === fileType) {
    //       console.log("iki file",list[i]); //print the file
    //     } else {
    //       console.log("iki folder", list[i]); //print the file
    //     }
    //   }
    // });
    this.fetch();
    this.startAnimation();
  },
  methods: {
    getValueByPath(obj, path) {
      // Convert brackets like [1] into dot notation like .1, then split by '.'
      const keys = path.replace(/\[(\d+)\]/g, '.$1').split('.');
      
      // Step through the keys sequentially
      return keys.reduce((acc, key) => {
        return (acc && acc[key] !== undefined) ? acc[key] : undefined;
      }, obj);
    },
    startAnimation() {
      gsap.from(".goverment", {
        y: -10,
        duration: 2,
        ease: "elastic",
      });
    },
    goBack() {
      this.$router.push({ name: "Home" });
    },
    async fetch() {
      this.data = [];
      await Promise.all([
        this.$store.dispatch("fetchListCorGov", { parent: null }),
        // this.$store.dispatch("fetchTeam"),
      ]).then(() => {
        let tempData = this.corGovList
        if (tempData) {
          for (let i = 0; i < tempData.length; i++) {
            tempData[i]['path'] = i.toString()
          }
        }
        this.data = tempData
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    actions(e, data) {
      e.stopPropagation()
      //console.log(data)
    },
    loadNode(node, resolve) {
      //console.log(node.data.id)
      // if (node.level === 0) {
      //   return resolve([{}]);
      // }

      const storage = JSON.parse(localStorage.getItem("token"));
      axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND + "api/corporateGovernance",
        params: { path: node.data.path, url: node.data.url },
        headers: {
          "Content-Type": "application/json",
          token: storage.token
        },
      })
        .then(res => {
          let result = res.data
          for (let i = 0; i < result.length; i++) {
            result[i]['path'] = node.data.length > 0 ? (node.data.path + "-" + i.toString()) : i.toString()

            if (node.level != 0) {
              let kdSource = node ? node.data.path.split("-") : null
              let funcString = ""
              let temdata = this.data
              for (let x = 0; x < kdSource.length; x++) {
                if (x == 0) {
                  funcString = "temdata[" + kdSource[x] + "]"
                } else {
                  funcString += ".children[" + kdSource[x] + "]"
                }
                if (x == kdSource.length - 1) {
                  if (!this.getValueByPath(temdata, funcString + ".children")) {
                    this.getValueByPath(temdata, funcString + "['children']=[]")
                    this.getValueByPath(temdata, funcString + ".children.push(result[" + i + "])")
                  } else {
                    this.getValueByPath(temdata, funcString + ".children.push(...[result[" + i + "]])")
                  }
                }
              }
              this.data = temdata
            } else {
              this.data.push(...[result[i]])
            }
          }
          return resolve(result)
        })
    },
    resetFormInput() {
      this.form.label = ''
      this.form.link = ''
      this.form.id_parent = null
      this.form.lbl_parent = null
      this.form.path = null
      this.form.as = null
      this.form.id = null
    },
    saveDataEntry(level) {
      let lbl = this.form.label ? (this.form.label.trim() != '' ? this.form.label.trim() : null) : null
      let link = this.form.link ? (this.form.link.trim() != '' ? this.form.link.trim() : null) : null
      let idPrn = this.form.id_parent ? (this.form.id_parent.trim() != '' ? this.form.id_parent.trim() : null) : null
      let path = this.form.path ? (this.form.path.trim() != '' ? this.form.path.trim() : null) : null
      if (lbl == null || (this.form.as == 'child' && link == null)) {
        this.$notify({
          title: 'Warning',
          message: this.form.id_parent != '' ? 'Label & Link must be filled!' : 'Label must be filled!',
          type: 'warning'
        });
        return
      }

      // var request = new XMLHttpRequest();
      // request.open('GET', link, true);
      const that = this
      // request.onreadystatechange = function () {
      //   if (request.readyState === 4) {
      //     if (request.status === 404) {
      //       that.$notify({
      //         title: 'Warning',
      //         message: 'Link is not correct!',
      //         type: 'warning'
      //       });
      //       return
      //     } else {
      const storage = JSON.parse(localStorage.getItem("token"));
      axios({
        method: "post",
        url: process.env.VUE_APP_BACKEND + "api/corporateGovernance",
        data: {
          label: lbl,
          link: link,
          level: idPrn,
          mode: this.dialogEditData ? 'edit' : 'new',
          id: this.dialogEditData ? this.form.id : null,
          path: path,
        },
        headers: {
          "Content-Type": "application/json",
          token: storage.token
        },
      })
        .then(res => {
          if (this.dialogNewData) {
            if (idPrn) {
              path = path.split("-")
              let tempdata = this.data;
              let funcString = ""
              for (let i = 0; i < path.length; i++) {
                if (i == 0) {
                  funcString += "tempdata[" + path[i] + "]"
                  if (i == path.length - 1 && 0 == path.length - 1) {
                    if (!this.getValueByPath(temdata, funcString + ".children")) {
                      this.getValueByPath(temdata, funcString + "['children']=[]")
                    }
                    funcString += ".children"
                  }
                  if (i == path.length - 1 && 0 != path.length - 1) {
                    if (!this.getValueByPath(temdata, funcString + ".children[0]")) {
                      this.getValueByPath(temdata, funcString + "['children']=[]")
                    }
                    funcString += ".children"
                  }
                } else if (i != path.length - 1) {
                  funcString += ".children[" + path[i] + "]"
                } else {
                  if (!this.getValueByPath(temdata, funcString + ".children[0]")) {
                    this.getValueByPath(temdata, funcString + "['children']=[]")
                  }
                  funcString += ".children"
                }
              }
              this.getValueByPath(temdata, funcString + ".push(res.data.data[0])")
              this.data = tempdata
            } else {
              let new_data = res.data.data[0];
              new_data['path'] = (this.data.length - 1).toString()
              this.data.push(new_data)
            }
            this.dialogNewData = false
            this.resetFormInput()
            that.$notify({
              title: 'Success',
              message: res.data.status,
              type: 'success'
            });
          } else {
            if (res.data.data[0] == null) {
              this.data[res.data.data[3]].label = res.data.data[2]
              this.data[res.data.data[3]].url = res.data.data[4]
            } else {
              let kdSource = res.data.data[3].split("-")
              let funcString = ""
              let temdata = this.data
              for (let x = 0; x < kdSource.length; x++) {
                if (x == 0) {
                  funcString = "temdata[" + kdSource[x] + "]"
                } else {
                  funcString += ".children[" + kdSource[x] + "]"
                }
                if (x == kdSource.length - 1) {
                  this.getValueByPath(temdata, funcString + ".label='" + res.data.data[2] + "'")
                  this.getValueByPath(temdata, funcString + ".prn='" + res.data.data[0] + "'")
                  this.getValueByPath(temdata, funcString + ".url=" + (res.data.data[4] ? ("'" + res.data.data[4] + "'") : 'null'))
                }
              }
              this.data = temdata
            }
            this.$notify({
              title: 'Success',
              message: res.data.status,
              type: 'success'
            });
            this.dialogEditData = false;
            this.resetFormInput()
          }
        })
        .catch(res => {
          that.$notify({
            title: 'Error',
            message: 'Something error, check on log!',
            type: 'error'
          });
          console.log(res)
        })
      //     }
      //   }
      // };
      // request.send()
    },
    handleAddData(data) {
      this.dialogNewData = true
      this.form.label = ''
      this.form.link = ''
      this.form.id_parent = ''
      this.form.lbl_parent = ''
      this.form.path = ''
      this.form.as = ''
    },
    handleAddSubData(data) {
      this.form.label = ''
      this.form.link = ''
      this.form.id_parent = data.id
      this.form.lbl_parent = data.label
      this.form.path = data.path
      this.form.as = 'child'
      this.dialogNewData = true
    },
    handleEditData(data) {
      this.dialogEditData = true
      this.form.id = data.id
      this.form.label = data.label
      this.form.link = data.url
      this.form.path = data.path
      this.form.as = data.url ? 'child' : 'parent'
      this.form.id_parent = data.prn
    },
    changeAs(val) {
      this.form.link = ''
    },
    onEnter(e) {
      if (e.key == "Enter") {
        e.preventDefault();
        this.saveDataEntry(null)
      }
    },
    gotoLink(url) {
      window.open(url, '_blank');
    },
    typeFilter(e) {
      if (e.key == 'Enter') {
        this.searching();
      }
    },
    searching() {
      if (this.filterText == '' || (this.filterText && this.filterText.trim().length < 3)) {
        this.search.status = false
        this.search.result = []
        this.load.searching = false
        this.$notify({
          title: 'Warning',
          message: 'Filter Keyword minimal 3 Character!',
          type: 'warning'
        });
      } else {
        const storage = JSON.parse(localStorage.getItem("token"));
        this.load.searching = true
        axios({
          method: "post",
          url: process.env.VUE_APP_BACKEND + "api/corporateGovernanceSearch",
          data: {
            keyword: this.filterText
          },
          headers: {
            "Content-Type": "application/json",
            token: storage.token
          },
        })
          .then(res => {
            this.search.result = res.data
            this.search.status = true
            this.load.searching = false
          })
          .catch(res => {
            this.load.searching = false
            this.search.status = true
            this.$notify({
              title: 'Error',
              message: 'Something error, check on log!',
              type: 'error'
            });
            console.log(res)
          })
      }
    },
    resetsearching() {
      this.search.result = []
      this.filterText = ''
      this.search.status = false
      this.load.searching = false
    }
  },
};
</script>

<style lang="scss" scoped>
$base-color: #ff9900;
$base-padding: 10px;

.goverment {
  background-color: darken(white, 2);
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  overflow: auto;
  z-index: 1;

  .header {
    padding: $space;
    border-bottom: 1px solid darken($base-color, 1);
  }

  .body {
    display: flex;
    flex-direction: column;
    overflow: auto;
    background-color: darken(white, 5);
    height: inherit;
    font-size: 14px;
  }
}

.form-wrapper {
  padding: $space $space * 3;

  .action {
    padding: $space 0;
  }
}

.tree-content {
  margin: $base-padding;
  height: auto;
  font-size: inherit !important;
}

.el-tree {
  background: none;
}

.el-button {
  border-color: darken($base-color, 10);
}

.el-button--primary {
  // padding:5px;
  // margin:5px;
  background: $base-color;

  &.fitContent {
    width: fit-content !important;
  }
}

.el-button--primary:hover {
  background: darken($base-color, 3);
}

.el-button--primary:active {
  background: darken($base-color, 7);
}

.tree-btn-action {
  padding: 0px;
  margin-right: 5px;
  color: $base-color;
  border: none;
}

.tree-btn-action:hover {
  background: darken($base-color, 5);
  color: white !important;
}

.page-title {
  color: darken($base-color, 7);
}

.el-popover {
  .el-popper {
    padding: 0px !important;
    min-width: 0px !important;
    width: fit-content !important;
  }
}

.edit-btn {
  background: #ed752f !important;
}

.edit-btn:hover {
  background: #ff8037 !important;
}

.edit-btn:active {
  background: #e05200 !important;
}

.el-link {
  font-size: inherit;
}

.el-link--default:hover {
  color: $base-color !important;
  border-color: $base-color !important;
}

.el-link--default:hover:after {
  color: $base-color !important;
  border-color: $base-color !important;
}

.el-button--primary {
  color: $base-color !important;
}

.el-button--primary:hover {
  color: White !important;
}

.el-button--primary:focus {
  color: White !important;
  background: #ff9900 !important;
}

.el-button--danger {
  color: #f56c6c !important;
}

.el-button--danger:hover {
  background-color: #f56c6c !important;
  color: white !important;
}

.el-button--danger:focus {
  background-color: #f56c6c !important;
  color: white !important;
}

.main-filter {
  margin: $base-padding $base-padding 0px $base-padding;
  width: auto;
}

.tree-wrapper {
  margin: $base-padding;
  overflow: auto;
  border: 0.1rem solid darken($base-color, 2);
  border-radius: 2px;
  height: inherit;
}

.el-table_1_column_1 {
  padding: 1px 0 !important;
}

.table-result-search .rows {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.custom-tree-node {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
}

.custom-tree-node .stat {
  font-size: 0.8em;
}

.table-result-search .stat {
  font-size: 0.8em;
}
</style>